// extracted by mini-css-extract-plugin
module.exports = {"dynamicVideoBanner":"style_dynamicVideoBanner__L4_Oa","dynamicVideoBlock":"style_dynamicVideoBlock__Onfp1","dynamicVideoBody":"style_dynamicVideoBody__S0T0K"};